import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Home, ArrowLeft, Search, LayoutDashboard } from 'lucide-react';
import Logo from '../components/ui/Logo';
import { useAuth } from '../contexts/AuthContext';

const NotFound = () => {
  const { user, isInitialized } = useAuth();
  const navigate = useNavigate();

  const quickLinks = user
    ? [
        { label: 'Dashboard', href: '/dashboard', icon: LayoutDashboard },
        { label: 'Lead Management', href: '/lead-management', icon: Search },
        { label: 'Communication Hub', href: '/communication-hub', icon: Home },
      ]
    : [
        { label: 'Home', href: '/', icon: Home },
        { label: 'Sign In', href: '/login', icon: ArrowLeft },
        { label: 'Register', href: '/register', icon: Search },
      ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 flex items-center justify-center p-4">
      <div className="w-full max-w-lg text-center">
        {/* Logo */}
        <div className="mb-8">
          <Logo size="large" variant="default" showText={true} linkTo={user ? '/dashboard' : '/'} />
        </div>

        {/* 404 Content */}
        <div className="bg-white rounded-2xl shadow-xl p-10">
          <div className="text-8xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600 mb-4">
            404
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-3">Page Not Found</h1>
          <p className="text-gray-600 mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>

          {/* Quick Links */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-8">
            {quickLinks?.map((link) => {
              const LinkIcon = link?.icon;
              return (
                <Link
                  key={link?.href}
                  to={link?.href}
                  className="flex items-center justify-center space-x-2 px-4 py-3 border border-gray-200 rounded-lg text-sm font-medium text-gray-700 hover:bg-blue-50 hover:border-blue-300 hover:text-blue-700 transition-all duration-200"
                >
                  <LinkIcon className="w-4 h-4" />
                  <span>{link?.label}</span>
                </Link>
              );
            })}
          </div>

          {/* Primary CTA */}
          <Link
            to={user ? '/dashboard' : '/'}
            className="inline-flex items-center space-x-2 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white px-8 py-3 rounded-lg font-semibold transition-all duration-200 transform hover:scale-105 shadow-lg"
          >
            <Home className="w-5 h-5" />
            <span>{user ? 'Back to Dashboard' : 'Back to Home'}</span>
          </Link>
        </div>

        <p className="mt-6 text-sm text-gray-500">
          Need help?{' '}
          <a href="mailto:support@leadgenproai.us" className="text-blue-600 hover:text-blue-700 font-medium">
            Contact Support
          </a>
        </p>
      </div>
    </div>
  );
};

export default NotFound;